import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Table, TableBody, TableRow, TableCell, Chip, TableHead } from '@material-ui/core'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { withRouter, RouteComponentProps } from 'react-router'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import { WithGlobalProgress } from 'src/type/lib/withGlobalProgress'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import { withGlobalProgress } from 'src/shared/GlobalProgress'
import { fetchDashboardCotations } from 'src/core/redux/action/dashboardAction'
import { cotationAssign, cotationStatus, replaceDetteWithTaux } from 'src/shared/utils/helpers'
import { Fender } from 'src/shared/Fender/Fender'
import { ICotation } from 'src/type/cotation'
import autobind from 'autobind-decorator'
import DashboardPanel from 'src/page/Consumer/Dashboard/DashboardPanel'
import DashboardLoading from 'src/page/Consumer/Dashboard/DashboardLoading'

const styles = (t: Theme) => createStyles({
  chip: {
      margin: '4px',
      fontSize: '0.75rem',
      height: '26px'
  },
  rowClickable: {
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.07)'
    }
  },
})

interface IProps extends WithI18n,
  WithGlobalProgress,
  WithToast,
  RouteComponentProps<any>,
  WithStyles<typeof styles>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>  {
}

interface IState {
  cotations: ICotation[];
  isFetching: boolean;
}

class DashboardCotations extends React.Component<IProps, IState> {
  state = {
    cotations: [] as ICotation[],
    isFetching: false
  }

  componentDidMount(){
    const {fcotations, promisesWithProgress, toastError} = this.props
    this.setState({isFetching: true})
    promisesWithProgress(
      fcotations().then(res => this.setState({cotations: res.data})).catch(err => toastError(err.msg)).finally(() => this.setState({isFetching: false})),
    )
  }

  render() {
    const {t, classes, mapName, mapProductType} = this.props
    const {cotations, isFetching} = this.state
    return (
        <DashboardPanel
            label={t.last_cotations}
            icon="record_voice_over"
            redirect="cotations"
            headerClickableRedirectOnly
        >
            {isFetching && <DashboardLoading />}
            {(cotations && cotations.length > 0 && !isFetching) &&
            <Table>
                <TableHead>
                    <TableRow>
                    <TableCell>{t.Cotation_table_column_name}</TableCell>
                    <TableCell>{t.status}</TableCell>
                    <TableCell>{t.Cotation_table_column_assignment}</TableCell>
                    <TableCell>{t.categories}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {cotations.map(c => (
                    <TableRow key={c.id} className={classes.rowClickable} onClick={() => this.redirectTo(`cotation/${c.product_type}/${c.id}`)}>
                        <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                            {mapProductType.get(c.product_type)}
                        </TableCell>
                        <TableCell >{cotationStatus(c.status)}</TableCell>
                        <TableCell >{cotationAssign(c.assigned_to)}</TableCell>
                        <TableCell style={{whiteSpace: 'normal', wordBreak: 'break-all'}}>
                            {c.category_principale && c.category_principale.length > 0 &&
                                c.category_principale.split(",").map(ca => 
                                    mapName.get(ca) !== undefined ? <Chip key={`${c.id}-category-principale-${ca}`} label={replaceDetteWithTaux(mapName.get(ca))} className={classes.chip}/> : ''
                                )
                            }
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
            }
            {(cotations && cotations.length === 0 && !isFetching) && <Fender text={t.Dashboard_no_cotation} />}
        </DashboardPanel>
    )
  }

  @autobind
  private redirectTo(url: string){
    this.props.history.push(`/ptf/enterprise/${this.props.enterprise.id}/${url}`)
  }
}

const state2props = (state: RootState) => ({
  mapName: state.utils.mapCategories,
  mapProductType: state.utils.mapProductType,
  news: state.paginate.news.entities,
  user: state.accountInfo.connectedUser,
  enterprise: state.accountInfo.enterpriseSelected,
});

const dispatch2props = (dispatch: any) => ({
  fcotations: () => dispatch(fetchDashboardCotations()),
});

export default compose(
  withI18n,
  withRouter,
  withGlobalProgress,
  withToast,
  withStyles(styles),
  connect(state2props, dispatch2props),
)(DashboardCotations)



// WEBPACK FOOTER //
// ./src/page/Consumer/Dashboard/tabs/DashboardCotations.tsx